import React from 'react';

import { ZIndex } from '@rover/constants/src/styles/ZIndex';
import { Box, Button, Flex, Text } from '@rover/kibble/core';

import {
  META_DISCOUNT_AMOUNT,
  META_DISCOUNT_AMOUNT_LABEL,
  META_DISCOUNT_CURRENCY_SYMBOL,
} from './constants';
import CouponIllustration from './CouponIllustration';

type MetaDiscountBannerProps = {
  onCtaClick: () => void;
};

const MetaDiscountBanner = ({ onCtaClick }: MetaDiscountBannerProps): JSX.Element => (
  <Box
    position="fixed"
    bottom="0"
    left="0"
    right="0"
    background="caution"
    py="4x"
    px="4x"
    zIndex={ZIndex.NAVBAR_FIXED.toString()}
    sx={{ boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.12)' }}
    testID="meta-discount-mini-banner"
  >
    <Flex flexDirection="row" alignItems="center" gap="4x">
      <CouponIllustration
        variant="compact"
        symbol={META_DISCOUNT_CURRENCY_SYMBOL}
        amount={META_DISCOUNT_AMOUNT}
      />
      <Flex flexDirection="column" alignItems="flex-start" flexGrow="1" minWidth="0">
        <Text size="100">
          {`Sign up and get ${META_DISCOUNT_AMOUNT_LABEL} off your first booking`}
        </Text>
        <Button variant="link" size="small" onPress={onCtaClick}>
          {`Sign up to claim your ${META_DISCOUNT_AMOUNT_LABEL}`}
        </Button>
      </Flex>
    </Flex>
  </Box>
);

export default MetaDiscountBanner;
